import { FacebookCustomEvent, FacebookStandardEvents } from '@xyo-network/sdk-xyo-react-js';
class FacebookEvents extends FacebookStandardEvents {
    contactInfoComplete() {
        return new FacebookCustomEvent('ContactInfoComplete');
    }
    addressInfoComplete() {
        return new FacebookCustomEvent('AddressInfoComplete');
    }
    paymentInfoComplete() {
        return new FacebookCustomEvent('PaymentInfoComplete');
    }
    transactionAttempted() {
        return new FacebookCustomEvent('TransactionAttempted');
    }
    transactionFailed() {
        return new FacebookCustomEvent('TransactionFailed');
    }
    transactionCompleted() {
        return new FacebookCustomEvent('TransactionCompleted');
    }
    upsellViewed() {
        return new FacebookCustomEvent('UpsellViewed');
    }
    upsellUnavailable() {
        return new FacebookCustomEvent('UpsellUnavailable');
    }
    upsellAccepted() {
        return new FacebookCustomEvent('UpsellAccepted');
    }
    upsellSucceeded() {
        return new FacebookCustomEvent('UpsellSucceeded');
    }
    trialStarted() {
        return new FacebookCustomEvent('TrialStarted');
    }
    upsellFailed() {
        return new FacebookCustomEvent('UpsellFailed');
    }
    testStarted() {
        return new FacebookCustomEvent('TestStarted');
    }
    funnelStarted() {
        return new FacebookCustomEvent('FunnelStarted');
    }
    funnelStartedStarted() {
        return new FacebookCustomEvent('FunnelStarted');
    }
    userClick() {
        return new FacebookCustomEvent('UserClick');
    }
}
export default FacebookEvents;
